const safeFilename = (value, fallback = "invoice-register.xlsx") => {
  const filename = String(value || "").trim();
  const hasControl = [...filename].some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127);
  return filename
    && filename.length <= 255
    && !hasControl
    && !filename.includes("/")
    && !filename.includes("\\")
    ? filename
    : fallback;
};

export const saveAccountFile = ({ blob, filename } = {}, runtime = window) => {
  if (!(blob instanceof Blob) || !blob.size || !runtime?.URL?.createObjectURL || !runtime?.document?.createElement) {
    throw new Error("The account file could not be downloaded.");
  }
  const safeName = safeFilename(filename);
  const url = runtime.URL.createObjectURL(blob);
  const anchor = runtime.document.createElement("a");
  anchor.href = url;
  anchor.download = safeName;
  runtime.document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  runtime.setTimeout(() => runtime.URL.revokeObjectURL(url), 0);
  return safeName;
};

export { safeFilename as safeAccountFilename };
